var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "4axgrfgbaa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 15,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.5C6.34 2.5 3 5.84 3 10s3.34 7.5 7.5 7.5S18 14.16 18 10s-3.34-7.5-7.5-7.5zm0 13.636A6.11 6.11 0 0 1 4.364 10 6.11 6.11 0 0 1 10.5 3.864 6.11 6.11 0 0 1 16.636 10a6.11 6.11 0 0 1-6.136 6.136zm2.523-3.613a.659.659 0 0 0 0-.955l-1.841-1.84V5.908c0-.409-.273-.682-.682-.682-.41 0-.682.273-.682.682V10c0 .204.068.34.205.477l2.045 2.046a.619.619 0 0 0 .478.204c.204 0 .34-.068.477-.204z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#4axgrfgbaa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M.5 0h20v20H.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInLine);
export default __webpack_public_path__ + "static/media/ic-in-line.6119c561c19dfd99645637448498b243.svg";
export { ForwardRef as ReactComponent };